import { InitialState } from '../state';
import { AppReducer } from './app-reducer';

export const sensorDetailReducer: AppReducer<'SensorDetailReport'> = (
    state = InitialState.SensorDetailReport,
    action
): typeof state => {
    switch (action.type) {
        case 'SensorDetailActions/Load/Started':
            return {
                ...state,
                loading: true,
                success: false,
                errorCode: '' 
            };
        case 'SensorDetailActions/Load/Succeeded':
            return {
                ...state,
                loading: false,
                success: true,  
                errorCode: '',
                deviceId: action.payload.data.deviceId, 
                deviceName: action.payload.data.deviceName,           
                channelData: action.payload.data.channelData
                   
            };
        case 'SensorDetailActions/Load/Failed':
            return {
                ...state,
                loading: false,
                success: false,
                errorCode: action.payload.errorCode
               
            };
        case 'SensorDetailActions/Load/Unmounted':
            return {
                ...state,
                loading: false,
                success: false,
                errorCode: ''               
            };
        default:
            return state;
    }
};
